"use strict";

/**
 * Empty component used for specifying route configuration.
 */
export function Screen(_) {
  /* istanbul ignore next */
  return null;
}
//# sourceMappingURL=Screen.js.map